import * as React from 'react';
import { TButtonTheme } from '@cian/ui-kit/button/types';
import { useDispatch, useSelector } from 'react-redux';

import { toggleCompare } from '../../actions/compare';
import { selectIsCompareAdded } from '../../selectors/compare';
import { useApplicationContext } from '../../utils/withApplicationContext';
import { CompareButtonControl } from './CompareButtonControl';
import { CompareButtonOnboarding } from './CompareButtonOnboarding';
import { COMPARE_ENABLED_CONFIG } from './constants';
import { useCompareOnboarding } from './useCompareOnboarding';

interface INewbuildingCompareButtonProps {
  hideText?: boolean;
  isHeader?: boolean;
  buttonTheme?: TButtonTheme;
  withOnboarding?: boolean;
}

export const NewbuildingCompareButton: React.FC<INewbuildingCompareButtonProps> = ({
  hideText = false,
  isHeader = false,
  buttonTheme,
  withOnboarding = false,
}) => {
  const { config } = useApplicationContext();
  const dispatch = useDispatch();
  const isAdded = useSelector(selectIsCompareAdded);
  const isCompareEnabled = config.get<boolean>(COMPARE_ENABLED_CONFIG) || false;
  const { open, closeHandler } = useCompareOnboarding(withOnboarding && isCompareEnabled);

  const handleClick = React.useCallback(() => {
    dispatch(toggleCompare());
  }, [dispatch]);

  if (!isCompareEnabled) {
    return null;
  }

  const button = (
    <CompareButtonControl
      hideText={hideText}
      isHeader={isHeader}
      buttonTheme={buttonTheme}
      isAdded={isAdded}
      onClick={handleClick}
    />
  );

  if (!withOnboarding || !open) {
    return button;
  }

  return (
    <CompareButtonOnboarding open={open} onClose={closeHandler}>
      {button}
    </CompareButtonOnboarding>
  );
};
